(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hvc-video-preorder"] && !Shopify.designMode) return;
  try {
    
  (function(){
    const videoCleanup = new WeakMap();
    function setupVideo(root, copy) {
      const video = root.querySelector('video');
      const soundButton = root.querySelector('[data-hvc-video-sound]');
      if (!video || !soundButton || !('IntersectionObserver' in window)) return function() {};
      const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      let visible = false;
      let autoplayReady = false;
      let destroyed = false;
      let userPaused = false;
      let needsInteraction = false;
      let internalPauses = 0;
      let revision = 0;
      let pending = null;
    
      function canPlay() {
        return !destroyed && visible && !document.hidden && !userPaused;
      }
      function canAutoplay() {
        return canPlay() && autoplayReady && !motion.matches && !video.ended;
      }
      function updateSoundButton() {
        soundButton.hidden = !(needsInteraction || video.muted || video.volume === 0);
        soundButton.textContent = video.paused ? copy.playWithSound : copy.enableSound;
      }
      function pause() {
        revision += 1;
        if (!video.paused) {
          internalPauses += 1;
          video.pause();
        }
      }
      async function play(manual) {
        if (!canPlay() || (!manual && (!canAutoplay() || pending || !video.paused))) return;
        const attempt = { revision: revision, manual: manual };
        pending = attempt;
        try {
          await video.play();
          if (!canPlay() || (!manual && motion.matches)) pause();
          else if (pending === attempt) needsInteraction = false;
        } catch (error) {
          if (attempt.revision !== revision || !canPlay()) return;
          if (!manual && error.name === 'NotAllowedError' && !video.muted) {
            video.muted = true;
            needsInteraction = true;
            updateSoundButton();
            try {
              await video.play();
              if (!canPlay() || motion.matches) pause();
            } catch (mutedError) {
              if (pending === attempt) needsInteraction = true;
            }
          } else if (error.name !== 'AbortError') {
            needsInteraction = true;
          }
        } finally {
          if (pending === attempt) {
            pending = null;
            updateSoundButton();
            if (attempt.revision !== revision && canAutoplay()) play(false);
          }
        }
      }
      function onPlay() {
        if (!pending) userPaused = false;
        if (!canPlay() || (pending && !pending.manual && motion.matches)) pause();
        else needsInteraction = false;
        updateSoundButton();
      }
      function onPause() {
        if (internalPauses) internalPauses -= 1;
        else if (!video.ended && visible && !document.hidden) {
          userPaused = true;
          revision += 1;
        }
        updateSoundButton();
      }
      function onEnded() {
        userPaused = true;
        revision += 1;
        updateSoundButton();
      }
      function onVisibility() {
        if (document.hidden) pause();
        else play(false);
      }
      function onMotion() {
        if (motion.matches) pause();
        else play(false);
      }
      function onSound() {
        userPaused = false;
        revision += 1;
        video.muted = false;
        if (video.volume === 0) video.volume = 1;
        play(true);
        updateSoundButton();
      }
      const observer = new IntersectionObserver(function(entries) {
        const entry = entries[entries.length - 1];
        visible = entry.isIntersecting && entry.intersectionRatio > 0;
        autoplayReady = visible && entry.intersectionRatio >= 0.5;
        if (autoplayReady) play(false);
        else if (!visible) pause();
      }, { threshold: [0, 0.5] });
      video.addEventListener('play', onPlay);
      video.addEventListener('pause', onPause);
      video.addEventListener('ended', onEnded);
      video.addEventListener('volumechange', updateSoundButton);
      soundButton.addEventListener('click', onSound);
      document.addEventListener('visibilitychange', onVisibility);
      motion.addEventListener('change', onMotion);
      observer.observe(video);
      updateSoundButton();
      return function() {
        destroyed = true;
        observer.disconnect();
        pause();
        video.removeEventListener('play', onPlay);
        video.removeEventListener('pause', onPause);
        video.removeEventListener('ended', onEnded);
        video.removeEventListener('volumechange', updateSoundButton);
        soundButton.removeEventListener('click', onSound);
        document.removeEventListener('visibilitychange', onVisibility);
        motion.removeEventListener('change', onMotion);
      };
    }
    function setup(root){
      if(root.dataset.ready)return;root.dataset.ready='true';
      const product=JSON.parse(root.querySelector('[data-hvc-product]').textContent)||{};
      const copy=JSON.parse(root.querySelector('[data-hvc-copy]').textContent);
      videoCleanup.set(root, setupVideo(root, copy));
      const variants=product.variants||[];
      const order=['Skirt','Top','Windbreaker'];
      const sizes=['Extra Small','Small','Medium','Large','Extra Large','2 Extra Large','3 Extra Large'];
      let selected=['Skirt'];const chosen={};let busy=false;let showPhotos=false;
      const form=root.querySelector('form');const submit=root.querySelector('.hvc-video-submit');const status=root.querySelector('.hvc-video-status');const box=root.querySelector('.hvc-video-sizes');
      function money(cents){return new Intl.NumberFormat(document.documentElement.lang||'en-ZA',{style:'currency',currency:copy.currency||'ZAR'}).format(cents/100)}
      function pieces(){return order.filter(function(piece){return selected.includes(piece)})}
      function current(){const list=pieces();return variants.find(function(v){return v.option1===list.join(' + ')&&v.option2===chosen[list[0]]&&v.option3===(list.length===2?chosen[list[1]]:'Not applicable')})}
      function update(){const variant=current();submit.disabled=busy||!variant||!variant.available;submit.textContent=busy?copy.adding:(variant&&!variant.available?copy.unavailable:copy.preorder)}
      function render(){
        const list=pieces();status.textContent='';
        root.querySelector('.hvc-video-frame').hidden=showPhotos;
        root.querySelector('[data-hvc-video-return]').hidden=!showPhotos;
        root.querySelectorAll('[data-hvc-gallery]').forEach(function(gallery){gallery.hidden=!showPhotos||(gallery.dataset.hvcGallery==='domino'?!list.some(function(piece){return piece==='Skirt'||piece==='Top'}):!list.includes('Windbreaker'))});
        root.querySelectorAll('[data-piece]').forEach(function(button){button.setAttribute('aria-pressed',String(selected.includes(button.dataset.piece)))});
        const priceVariant=variants.find(function(v){return v.option1===list.join(' + ')});root.querySelector('.hvc-video-price').textContent=priceVariant?money(priceVariant.price):copy.unavailable;
        box.replaceChildren();list.forEach(function(piece){const label=document.createElement('label');const select=document.createElement('select');const id='hvc-size-'+root.dataset.sectionId+'-'+piece.toLowerCase();label.htmlFor=id;label.textContent=copy[piece.toLowerCase()]+' '+copy.size;select.id=id;select.name='properties['+piece+' size]';select.dataset.size=piece;select.required=true;const placeholder=document.createElement('option');placeholder.value='';placeholder.textContent=copy.chooseSize;select.appendChild(placeholder);sizes.forEach(function(size){const option=document.createElement('option');option.value=size;option.textContent=size;select.appendChild(option)});select.value=chosen[piece]||'';select.addEventListener('change',function(){chosen[piece]=select.value;update()});box.append(label,select)});update();
      }
      root.querySelector('[data-hvc-video-return]').addEventListener('click',function(){showPhotos=false;render();const video=root.querySelector('video');if(video)video.play().catch(function(){})});
      root.querySelectorAll('[data-hvc-photo]').forEach(function(button){button.addEventListener('click',function(){const image=button.closest('[data-hvc-gallery]').querySelector('.hvc-piece-main');image.removeAttribute('srcset');image.src=button.dataset.hvcPhoto;image.alt=button.dataset.hvcPhotoAlt})});
      root.querySelectorAll('[data-piece-price]').forEach(function(span){const variant=variants.find(function(v){return v.option1===span.dataset.piecePrice});span.textContent=variant?money(variant.price):''});
      root.querySelectorAll('[data-piece]').forEach(function(button){button.addEventListener('click',function(){if(busy)return;const piece=button.dataset.piece;showPhotos=true;const clip=root.querySelector('video');if(clip)clip.pause();if(selected.includes(piece)){if(selected.length>1)selected=selected.filter(function(item){return item!==piece})}else if(selected.length<2){selected.push(piece)}else{status.textContent=copy.chooseTwo;return}render()})});
      form.addEventListener('submit',async function(event){event.preventDefault();if(busy||!form.reportValidity())return;const variant=current();if(!variant||!variant.available)return;const properties={Type:'Preorder','Pre-order dispatch':copy.dispatch};pieces().forEach(function(piece){properties[piece+' size']=chosen[piece]});busy=true;status.textContent='';update();try{const response=await fetch(root.dataset.addUrl,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:variant.id,quantity:1,properties:properties}]})});const data=await response.json();if(!response.ok)throw new Error(typeof data.description==='string'?data.description:copy.error);window.location.assign(root.dataset.cartUrl)}catch(error){status.textContent=error.message||copy.error;busy=false;update()}});render();
    }
    document.querySelectorAll('.hvc-video-feature[data-hvc-preorder]').forEach(setup);
    document.addEventListener('shopify:section:load',function(event){event.target.querySelectorAll('.hvc-video-feature[data-hvc-preorder]').forEach(setup)});
    document.addEventListener('shopify:section:unload',function(event){event.target.querySelectorAll('.hvc-video-feature[data-hvc-preorder]').forEach(function(root){const cleanup=videoCleanup.get(root);if(cleanup)cleanup();videoCleanup.delete(root)})});
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
